function seededRandom(seed) {
  let s = seed;
  return function () {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export function generateChartData(days = 30) {
  const rand = seededRandom(42);
  const data = [];
  const now = new Date();

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      visitors: Math.round(1200 + rand() * 3000 + (days - i) * 30),
      pageViews: Math.round(3000 + rand() * 8000 + (days - i) * 60),
      sessions: Math.round(800 + rand() * 2000 + (days - i) * 20),
      bounceRate: Math.round(30 + rand() * 25),
      revenue: Math.round(500 + rand() * 2000 + (days - i) * 15),
    });
  }
  return data;
}

export const KPI_DATA = {
  totalVisitors: { value: '127,543', change: '+12.5%', positive: true, icon: '👥' },
  totalRevenue: { value: '$48,295', change: '+8.3%', positive: true, icon: '💰' },
  conversionRate: { value: '3.24%', change: '+0.5%', positive: true, icon: '🎯' },
  avgSessionDuration: { value: '4m 32s', change: '-2.1%', positive: false, icon: '⏱️' },
  bounceRate: { value: '38.7%', change: '-3.2%', positive: true, icon: '📉' },
  newUsers: { value: '34,291', change: '+15.8%', positive: true, icon: '🆕' },
};

export const TRAFFIC_SOURCES = [
  { name: 'Organic Search', value: 42, color: '#7c83ff' },
  { name: 'Direct', value: 24, color: '#e040fb' },
  { name: 'Social Media', value: 18, color: '#00d2d3' },
  { name: 'Referral', value: 10, color: '#ff6b35' },
  { name: 'Email', value: 6, color: '#ffd32a' },
];

export const TOP_PAGES = [
  { path: '/home', views: 45234, unique: 32100, avgTime: '3:21', bounce: '32%' },
  { path: '/products', views: 28912, unique: 21450, avgTime: '4:12', bounce: '28%' },
  { path: '/pricing', views: 19843, unique: 15230, avgTime: '2:45', bounce: '41%' },
  { path: '/blog/react-tips', views: 15632, unique: 12890, avgTime: '5:30', bounce: '22%' },
  { path: '/about', views: 12456, unique: 9870, avgTime: '2:10', bounce: '45%' },
  { path: '/contact', views: 8234, unique: 6540, avgTime: '1:45', bounce: '52%' },
  { path: '/docs/api', views: 7123, unique: 5890, avgTime: '6:15', bounce: '18%' },
];

export const DEVICES = [
  { name: 'Desktop', value: 54, icon: '🖥️' },
  { name: 'Mobile', value: 38, icon: '📱' },
  { name: 'Tablet', value: 8, icon: '📟' },
];

export const COUNTRIES = [
  { name: 'United States', code: '🇺🇸', visitors: 42350, pct: 33.2 },
  { name: 'United Kingdom', code: '🇬🇧', visitors: 18920, pct: 14.8 },
  { name: 'Germany', code: '🇩🇪', visitors: 12450, pct: 9.8 },
  { name: 'Canada', code: '🇨🇦', visitors: 9870, pct: 7.7 },
  { name: 'Australia', code: '🇦🇺', visitors: 8340, pct: 6.5 },
  { name: 'France', code: '🇫🇷', visitors: 7210, pct: 5.7 },
  { name: 'Japan', code: '🇯🇵', visitors: 6890, pct: 5.4 },
  { name: 'India', code: '🇮🇳', visitors: 5430, pct: 4.3 },
];

export const RECENT_ACTIVITY = [
  { type: 'purchase', text: 'New purchase from John D. — $129.99', time: '2 min ago' },
  { type: 'signup', text: 'New user registered — sarah.chen@email.com', time: '5 min ago' },
  { type: 'review', text: '5-star review on "Wireless Headphones Pro"', time: '12 min ago' },
  { type: 'purchase', text: 'New purchase from Alex R. — $299.99', time: '18 min ago' },
  { type: 'alert', text: 'Server response time exceeded 200ms threshold', time: '25 min ago' },
  { type: 'signup', text: 'New user registered — david.kim@email.com', time: '32 min ago' },
  { type: 'purchase', text: 'New purchase from Maya P. — $79.99', time: '45 min ago' },
  { type: 'review', text: '4-star review on "Smart Watch Ultra"', time: '1 hr ago' },
];
